import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { CUSTOMER_INTAKE_ENDPOINT } from '../signup/intake/customer-intake.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const token = auth.getToken();
  // A request that brings its own credentials (the /signup intake token) isn't a login session
  const ownCredentials = req.headers.has('Authorization');
  // Nor are /signup's public intake calls (the address lookup has no token): a 401 there isn't a lapsed login, and a
  // new customer can't log in until their account is set up
  const signup = req.url.startsWith(`${environment.apiUrl}${CUSTOMER_INTAKE_ENDPOINT}`);
  // Only the property-tax API holds the login session: a 401 elsewhere (dot-com's quote API) says nothing about it
  const api = req.url.startsWith(environment.apiUrl);

  if (token && !ownCredentials && !signup && api) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req).pipe(
    tap({
      error: (err) => {
        if (err.status === 401 && api && !ownCredentials && !signup && !req.url.includes('/auth/verify-otp')) {
          auth.logout();
          router.navigate(['/login']);
        }
      },
    }),
  );
};
